var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setisSolaceEnabled } from "src/redux/reducers/common-reducer";
import { store } from "src/redux/store";
import { dataCheckerInterval, lastSyncTime, updateSocketConnectTime, } from "src/utils/loggly-method";
import { charFromBytes, checkIsEmpty, floatFromBytes, getMethodTypeFromTopic, intFromBytes, newDecrypt, parseTopic, shortFromBytes, } from "src/utils/methods";
import { SESSION_KEYS, getDataFromSession, setDataInSession, } from "src/utils/session-storage";
import { analyticsAPIClickhouse, getMarketFeedV4 } from "../apis/dashboard";
import { ANALYTICS_API_FAILURE, SOCKET_EVENT, SOCKET_SUBSCRIPTION_METHODS, SOLACE, SOLACE_20DEPTH_TOPIC_PREFIX, SOLACE_CONNECTION_FAILED, SOLACE_CONNECTION_SUCCESS, SOLACE_GREEKS_TOPIC_PREFIX, SOLACE_SOCKET_CONNECT, SOLACE_SOCKET_OPEN, SOLACE_SOCKET_RECONNECT, SOLACE_TIME_FORMAT, } from "../utils/constant";
// import { getSocketLogMessage, logMessage } from "../utils/custom-loggly";
// import { remoteConfigData } from "../utils/custom-remote-config";
// import { checkIsEmpty } from "../utils/methods";
const { REACT_APP_ENV, REACT_APP_URL_WEBSOCKET } = process.env;
import MQTT from "mqtt";
import { handleMessageFromSocket } from "src/utils/solacesocketwrapper";
import moment from "moment";
let client;
let username;
let connectionStatusInterval;
let dataUpdateInterval;
let isWindowFocused = true;
let isSolaceConnect = false;
// let countForHeartBeat = 0;
let isSocketInitLoading = false;
const subscriberList = [];
let isSocketConnected = false;
let isDataLoading = false;
const scripMap = {};
let solaceConnectDuration = 0;
const setSocketInitLoading = (newValue) => {
    isSocketInitLoading = newValue;
};
let solaceTimer = 0;
let solaceLogsArray = [];
let shouldLog = true;
const setSocketConnected = (newValue) => {
    isSocketConnected = newValue;
    publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
        resetLastSyncTime: isSocketConnected ? "CONNECT" : "DISCONNECT",
    });
    const duration = updateSocketConnectTime(isSocketConnected);
    publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
        method: isSocketConnected ? "CONNECT" : "DISCONNECT",
        reason: { disconnectedDuration: duration },
    });
    if (newValue && isWindowFocused) {
        if (!dataCheckerInterval) {
            publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                dataCheckForConnectedSocket: isSocketConnected,
                isWindowFocused: isWindowFocused,
            });
        }
        if (!dataUpdateInterval) {
            // Commented to remove throttling
            dataUpdateInterval = setInterval(() => {
                checkSyncTimeAndDispatchData();
            }, 500);
        }
    }
    else if (dataUpdateInterval) {
        clearInterval(dataUpdateInterval);
        dataUpdateInterval = undefined;
        // countForHeartBeat = 0;
    }
};
const checkSyncTimeAndDispatchData = () => {
    // countForHeartBeat++;
    // if (countForHeartBeat == 4) {
    //   countForHeartBeat = 0;
    // if (
    //   isSocketConnected &&
    //   (REACT_APP_ENV == "production" || REACT_APP_ENV == "staging")
    // ) {
    //   socket?.send("Hi this is a heartbeat message");
    // }
    // }
    Object.keys(scripMap).forEach((singleScripKey) => {
        const scripObj = scripMap[singleScripKey];
        if (scripObj === null || scripObj === void 0 ? void 0 : scripObj.data) {
            checkAndDispatchSingleMessageAsPerType(scripObj, false);
        }
    });
};
export const subscribeToData = (subscriptionMethod, subscriberName
// callBackMethod?: any
) => {
    let subsData = subscriberList.find((singleSubData) => {
        if (subscriptionMethod.Method === singleSubData.Method) {
            return singleSubData;
        }
    });
    if (subsData) {
        subsData.MarketFeedData.push(...subscriptionMethod.MarketFeedData);
        // scripMap
        subsData.MarketFeedData = arrayUnique(subsData.MarketFeedData);
    }
    else {
        subsData = subscriptionMethod;
        subscriberList.push(subscriptionMethod);
    }
    const uniqueRequestArray = [];
    subscriptionMethod.MarketFeedData.forEach((singleElement) => {
        const isNew = addSingleScripSubscriber(subscriberName, singleElement, subscriptionMethod.Method);
        if (isNew) {
            // if (
            //   singleElement.ScripCode == 11536 ||
            //   singleElement.ScripCode == 532540
            // ) {
            //   console.log(isNew, " isNew");
            // }
            uniqueRequestArray.push(singleElement);
        }
        else {
            const scripObj = scripMap[singleElement.Exch + singleElement.ExchType + singleElement.ScripCode];
            // if (
            //   singleElement.ScripCode == 11536 ||
            //   singleElement.ScripCode == 532540
            // ) {
            //   console.log(JSON.stringify(scripObj), " scripObj");
            // }
            if (scripObj.data != undefined) {
                let currentData = undefined;
                if (subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS) {
                    currentData = scripObj.data.greekFeedData;
                }
                else if (subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE) {
                    currentData = scripObj.data.marketDepthData;
                }
                else if (subscriptionMethod.Method ==
                    SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3) {
                    currentData = scripObj.data.marketFeedData;
                }
                else if (subscriptionMethod.Method ==
                    SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE) {
                    currentData = scripObj.data.openInterest;
                }
                if (currentData != undefined) {
                    checkAndDispatchSingleMessage(scripObj, currentData, true, subscriptionMethod.Method);
                }
            }
        }
    });
    if (uniqueRequestArray.length > 0) {
        subscriptionMethod.MarketFeedData = uniqueRequestArray;
    }
    else {
        return;
    }
    //TODO comment to remove unsubscribe logic
    // if (isWindowFocused) {
    if (isSocketConnected) {
        sendMessage(subscriptionMethod);
    }
    else {
        getDataFromMarketFeed();
    }
    // }
};
const addSingleScripSubscriber = (subscriberName, marketFeedSingleElement, methodName) => {
    let scripObj = scripMap[marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode];
    if (scripObj) {
        const subsObj = scripObj.subscribers.find((singleElement) => {
            const isAlreadySubscribed = singleElement.componentName == subscriberName;
            return isAlreadySubscribed;
        });
        if (subsObj) {
            const alreadySubscribedMethod = subsObj.method.find((singleElement) => {
                return singleElement == methodName;
            });
            //Just updating it in case there was rerender.Ideally this component itself will not call again
            // subsObj.callback = callBackMethod;
            if (checkIsEmpty(alreadySubscribedMethod)) {
                subsObj.method.push(methodName);
                return true;
            }
            else {
                return false;
            }
        }
        else {
            scripObj.subscribers.push({
                method: [methodName],
                componentName: subscriberName,
            });
            return true;
        }
    }
    else {
        scripObj = {
            subscribers: [
                {
                    method: [methodName],
                    componentName: subscriberName,
                },
            ],
            data: undefined,
            lastUpdateTime: undefined,
        };
        scripMap[marketFeedSingleElement.Exch +
            marketFeedSingleElement.ExchType +
            marketFeedSingleElement.ScripCode] = scripObj;
        return true;
    }
};
export const unsubscribeDataBySubscriber = (subscriberName, methodName) => {
    Object.keys(scripMap).forEach((singleScripKey) => {
        unSubscribeDataByScripKey(subscriberName, singleScripKey, methodName);
    });
};
const unsubscribeDataByScrip = (subsriberName, marketFeedSingleElement, methodName) => {
    unSubscribeDataByScripKey(subsriberName, getScripKey(marketFeedSingleElement), methodName);
};
const unSubscribeDataByScripKey = (subscriberName, singleScripKey, methodName) => {
    const scripObj = scripMap[singleScripKey];
    if (scripObj) {
        //second condition is added to remove compile issue if its undefined/empty then first condition will be true
        if (checkIsEmpty(methodName) || methodName == undefined) {
            const newSubList = scripObj.subscribers.filter((singleElement) => {
                return singleElement.componentName != subscriberName;
            });
            if (newSubList.length > 0) {
                scripObj.subscribers = newSubList;
            }
            else {
                unsubscribeFromSocket(singleScripKey.charAt(0), singleScripKey.charAt(1), parseInt(singleScripKey.substring(2)));
                delete scripMap[singleScripKey];
            }
        }
        else {
            const newSubList = scripObj.subscribers.filter((singleElement) => {
                return singleElement.componentName == subscriberName;
            });
            if (newSubList.length > 0) {
                const newMethodList = newSubList[0].method.filter((singleMethod) => {
                    return singleMethod != methodName;
                });
                checkIfMethodIsSubscribed(scripObj, methodName);
                if (newMethodList.length > 0) {
                    newSubList[0].method = newMethodList;
                }
                else {
                    //Recursive call as we need to remove the subscriber itself
                    unSubscribeDataByScripKey(subscriberName, singleScripKey);
                }
            }
        }
    }
};
const arrayUnique = (array) => {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
            if (a[i].ScripCode == a[j].ScripCode && a[i].Exch == a[j].Exch)
                a.splice(j--, 1);
        }
    }
    return a;
};
// const compareAndGetNewObjectsArray = (newSubList: SocketDataType[], currSubList: SocketDataType[]): SocketDataType[] =>{}
const getScripKey = (marketFeedSingleElement) => {
    return (marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode);
};
const sendMessage = (subscriptionMethod) => {
    if (REACT_APP_ENV === "development") {
        subscriptionMethod.ClientCode = "54311569";
    }
    try {
        if (isSocketConnected) {
            //TESTING REMOVE
            subscriptionMethod.MarketFeedData.forEach((singleElement) => {
                let temp;
                if (subscriptionMethod.Method ==
                    SOCKET_SUBSCRIPTION_METHODS.DEPTH_20_SERVICE) {
                    temp =
                        SOLACE_20DEPTH_TOPIC_PREFIX +
                            singleElement.Exch.toLowerCase() +
                            singleElement.ExchType.toLowerCase() +
                            singleElement.ScripCode;
                }
                else if (subscriptionMethod.Method == SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS) {
                    temp = SOLACE_GREEKS_TOPIC_PREFIX + singleElement.ScripCode;
                }
                else {
                    return;
                }
                solace(temp, subscriptionMethod.Operation);
            });
        }
    }
    catch (error) {
        console.error(error);
    }
};
const sendAllMessage = (localSubscribeList) => {
    localSubscribeList.forEach((singleElement) => {
        sendMessage(singleElement);
    });
};
const updateSocketConnectedStateAndSendData = (val) => {
    if (client.connected) {
        //setSocketConnected(true);
        //publishMessage(SOCKET_EVENT.SOCKET_STATUS, { isConnected: true });
        isSolaceConnect = true;
        const duration = new Date().getTime() - solaceConnectDuration;
        publishMessage(SOCKET_EVENT.SOLACE_CONNECTED, {
            method: SOLACE_CONNECTION_SUCCESS,
            reason: {
                reason: SOLACE_SOCKET_CONNECT,
                duration: duration,
                isWindowFocused: isWindowFocused,
                socketOpenTime: val,
            },
        });
        sendAllMessage(subscriberList);
        connectionStatusInterval = undefined;
        solaceConnectDuration = 0;
    }
    else {
        connectionStatusInterval = setTimeout(() => {
            updateSocketConnectedStateAndSendData(val);
        }, 1000);
    }
};
const onSocketOpen = (reconnect) => {
    if (connectionStatusInterval == undefined) {
        const duration = new Date().getTime() - solaceConnectDuration;
        publishMessage(SOCKET_EVENT.SOLACE_CONNECTED, {
            method: SOLACE_CONNECTION_SUCCESS,
            reason: {
                reason: reconnect ? SOLACE_SOCKET_RECONNECT : SOLACE_SOCKET_OPEN,
                duration: duration,
                isWindowFocused: isWindowFocused,
            },
        });
        solaceConnectDuration = new Date().getTime();
        updateSocketConnectedStateAndSendData(duration);
    }
    // IF SANDESH CONNECTED, CHANGES STATUS OF VARIABLE FOR USE FOR AVOID RETRY CONNECTION
};
const getDataFromMarketFeed = () => __awaiter(void 0, void 0, void 0, function* () {
    // isDataLoading = true;
    if (isDataLoading || isSocketConnected || !isWindowFocused) {
        return;
    }
    // if (isDataLoading) {
    //   return;
    // }
    const marketFeedSubscriber = subscriberList.find((singleData) => {
        if (singleData.Method == "MarketFeedV3") {
            return singleData;
        }
    });
    if (!marketFeedSubscriber) {
        return;
    }
    const promises = [];
    const listLength = marketFeedSubscriber.MarketFeedData.length;
    const loopLength = listLength <= 50 ? 1 : listLength / 50 + 1;
    for (let i = 0; i < loopLength * 50; i = i + 50) {
        let endSize = i + 50;
        if (endSize > listLength) {
            endSize = listLength;
        }
        if (i > listLength) {
            break;
        }
        isDataLoading = true;
        const body = {
            MarketFeedData: marketFeedSubscriber.MarketFeedData.slice(i, endSize),
            Count: endSize - i,
            ClientLoginType: 0,
            LastRequestTime: "/Date(0)/",
            RefreshRate: "H",
        };
        if (!checkIsEmpty(body.MarketFeedData))
            promises.push(getMarketFeedV4(body));
    }
    try {
        const resultArray = yield Promise.all(promises);
        resultArray.forEach((singleCallresult) => {
            var _a, _b;
            const finalResult = ((_b = (_a = singleCallresult === null || singleCallresult === void 0 ? void 0 : singleCallresult.data) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.Data) || [];
            finalResult.forEach((element) => {
                handleAndDispatchMessage(element, SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3);
            });
        });
    }
    catch (err) {
        console.error(err);
    }
    finally {
        isDataLoading = false;
    }
    setTimeout(() => {
        getDataFromMarketFeed();
    }, 2000);
});
const handleAndDispatchMessage = (message, methodName) => {
    if (message) {
        // if (message.ReqType) {
        //   publishMessage(SOCKET_EVENT.ORDER_DATA, message);
        //   return;
        // } else if (message.PacketIdentifier && message?.PacketIdentifier == "G") {
        //   message.Exch = message.Exch ? message.Exch : "N";
        //   message.ExchType = message.ExchType ? message.ExchType : "D";
        // } else if (message.Exch == undefined) {
        //   return;
        // }
        if (Date.now() - lastSyncTime > 3000) {
            publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                resetLastSyncTime: "DATA_STARTED_COMING",
            });
            // resetLastSyncTime("DATA_STARTED_COMING");
        }
        const key = message.Exch + message.ExchType + message.Token + "";
        const scripObj = scripMap[key];
        if (scripObj) {
            scripObj.lastUpdateTime = new Date();
            let dataObj;
            if (scripObj === null || scripObj === void 0 ? void 0 : scripObj.data) {
                dataObj = scripObj.data;
            }
            else {
                dataObj = {};
                scripObj.data = dataObj;
            }
            let selectedSocketResponseSyncObject;
            if (methodName == SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE) {
                if (dataObj.openInterest == undefined) {
                    dataObj.openInterest = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.openInterest.response = message;
                    dataObj.openInterest.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.openInterest;
            }
            else if (methodName == SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE) {
                if (!dataObj.marketDepthData) {
                    dataObj.marketDepthData = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.marketDepthData.response = message;
                    dataObj.marketDepthData.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.marketDepthData;
            }
            else if (methodName == SOCKET_SUBSCRIPTION_METHODS.DEPTH_20_SERVICE) {
                if (!dataObj.market20DepthData) {
                    dataObj.market20DepthData = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.market20DepthData.response = message;
                    dataObj.market20DepthData.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.market20DepthData;
            }
            else if (methodName == SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS) {
                if (!dataObj.greekFeedData) {
                    dataObj.greekFeedData = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.greekFeedData.response = message;
                    dataObj.greekFeedData.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.greekFeedData;
            }
            else if (methodName == SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3) {
                if (dataObj.marketFeedData == undefined) {
                    dataObj.marketFeedData = {
                        lastUpdateTime: scripObj.lastUpdateTime,
                        response: message,
                    };
                }
                else {
                    dataObj.marketFeedData.response = message;
                    dataObj.marketFeedData.lastUpdateTime = scripObj.lastUpdateTime;
                }
                selectedSocketResponseSyncObject = dataObj.marketFeedData;
            }
            else {
                //unkown/unhandled packet type
                return;
            }
            // if (!selectedSocketResponseSyncObject.syncTime) {
            //   dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
            // }
            const isDataSubscribed = checkAnddispatchDataUsingCallBack(scripObj, message, methodName);
            if (isDataSubscribed) {
                //Commented this to remove throttling completely
                // if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "development") {
                //   dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject);
                // } else
                if (!selectedSocketResponseSyncObject.syncTime) {
                    dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject, methodName);
                }
            }
            else {
                // unsubscribeSpecificMethodFromSocket(
                //   message.Exch,
                //   message.ExchType,
                //   message.Token,
                //   methodName
                // );
            }
        }
        else if (isSocketConnected) {
            // unsubscribeFromSocket(message.Exch, message.ExchType, message.Token);
        }
    }
};
const checkAnddispatchDataUsingCallBack = (scripObj, message, methodName) => {
    let isDataSubscribed = false;
    scripObj.subscribers.forEach((singleSubscriber) => {
        let localSubsribed = false;
        singleSubscriber.method.forEach((singleMethod) => {
            if (singleMethod == methodName) {
                isDataSubscribed = true;
                localSubsribed = true;
            }
        });
        if (localSubsribed && singleSubscriber.callback) {
            singleSubscriber.callback(message);
        }
    });
    return isDataSubscribed;
};
const checkIfMethodIsSubscribed = (scripObj, methodName) => {
    let isDataSubscribed = false;
    scripObj.subscribers.forEach((singleSubscriber) => {
        singleSubscriber.method.forEach((singleMethod) => {
            if (singleMethod == methodName) {
                isDataSubscribed = true;
            }
        });
    });
    return isDataSubscribed;
};
const checkAndDispatchSingleMessageAsPerType = (scripObj, sendDataAgain) => {
    var _a, _b, _c, _d, _e;
    if ((_a = scripObj.data) === null || _a === void 0 ? void 0 : _a.marketDepthData) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.marketDepthData, sendDataAgain, SOCKET_SUBSCRIPTION_METHODS.DEPTH_SERVICE);
    }
    else if ((_b = scripObj.data) === null || _b === void 0 ? void 0 : _b.market20DepthData) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.market20DepthData, sendDataAgain, SOCKET_SUBSCRIPTION_METHODS.DEPTH_20_SERVICE);
    }
    if ((_c = scripObj.data) === null || _c === void 0 ? void 0 : _c.openInterest) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.openInterest, sendDataAgain, SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE);
    }
    if ((_d = scripObj.data) === null || _d === void 0 ? void 0 : _d.marketFeedData) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.marketFeedData, sendDataAgain, SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3);
    }
    if ((_e = scripObj.data) === null || _e === void 0 ? void 0 : _e.greekFeedData) {
        checkAndDispatchSingleMessage(scripObj, scripObj.data.greekFeedData, sendDataAgain, SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS);
    }
};
const checkAndDispatchSingleMessage = (scripObj, selectedSocketResponseSyncObject, sendDataAgain, methodName) => {
    // if (selectedSocketResponseSyncObject.response?.Token == 58684) {
    //   console.log(
    //     "GD message sent from solacewrapper for greeks topic : " +
    //       selectedSocketResponseSyncObject.response.Token,
    //     selectedSocketResponseSyncObject.response
    //   );
    // }
    if (!selectedSocketResponseSyncObject.syncTime) {
        dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject, methodName);
    }
    else if (selectedSocketResponseSyncObject.syncTime ==
        selectedSocketResponseSyncObject.lastUpdateTime &&
        !sendDataAgain) {
        //DO nothing as latest data is already updated
    }
    //Commented this to remove throttling
    // if (
    // DATA_UI_REFRESHRATE <=
    // selectedSocketResponseSyncObject.lastUpdateTime.getTime() -
    //   selectedSocketResponseSyncObject.syncTime.getTime()
    // )
    else {
        //This is added for testing only
        // if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "production")
        dispatchSingleMessage(scripObj, selectedSocketResponseSyncObject, methodName);
    }
    // else {
    //   //Do nothing as data is already updated within the window. This is the throttled data
    // }
};
const dispatchSingleMessage = (scripObj, selectedSocketResponseSyncObject, methodName) => {
    selectedSocketResponseSyncObject.syncTime =
        selectedSocketResponseSyncObject.lastUpdateTime;
    if (selectedSocketResponseSyncObject.response &&
        selectedSocketResponseSyncObject.response.PacketIdentifier == "G") {
        publishMessage(methodName, selectedSocketResponseSyncObject.response);
    }
    else {
        publishMessage(methodName, selectedSocketResponseSyncObject.response);
    }
};
const unsubscribeFromSocket = (exch, exchType, scripCode) => {
    if (subscriberList.length > 0) {
        // unsubscribeSpecificMethodFromSocket(
        //   exch,
        //   exchType,
        //   scripCode,
        //   "MarketFeedV3"
        // );
        // unsubscribeSpecificMethodFromSocket(
        //   exch,
        //   exchType,
        //   scripCode,
        //   "GetScripInfoForFuture"
        // );
        unsubscribeSpecificMethodFromSocket(exch, exchType, scripCode, "BaseGreeks");
        // unsubscribeSpecificMethodFromSocket(
        //   exch,
        //   exchType,
        //   scripCode,
        //   "MarketDepthService"
        // );
        unsubscribeSpecificMethodFromSocket(exch, exchType, scripCode, "20Depth");
    }
};
const unsubscribeSpecificMethodFromSocket = (exch, exchType, scripCode, methodName) => {
    if (subscriberList.length > 0) {
        const method1 = {
            Method: methodName,
            Operation: "UnSubscribe",
            ClientCode: subscriberList[0].ClientCode,
            MarketFeedData: [
                { Exch: exch, ExchType: exchType, ScripCode: scripCode },
            ],
        };
        sendMessage(method1);
    }
};
export const unSubscribeAllData = () => {
    isWindowFocused = false;
    if (dataUpdateInterval) {
        clearInterval(dataUpdateInterval);
        dataUpdateInterval = undefined;
        // countForHeartBeat = 0;
    }
    // const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    // if (clientCode && remoteConfigData) {
    //   const isClientCodePresent = remoteConfigData.clientlist.find(
    //     (singleClientCode) => {
    //       return singleClientCode == clientCode;
    //       // return singleClientCode == "57675310";
    //     }
    //   );
    //   if (isClientCodePresent) {
    //     return;
    //   }
    // }
    const cloneData = JSON.parse(JSON.stringify(subscriberList));
    cloneData.forEach((singleSubscription) => {
        singleSubscription.Operation = "UnSubscribe";
    });
    sendAllMessage(cloneData);
};
const onSocketError = (event, options) => {
    //setSocketConnected(false);
    setSocketInitLoading(false);
    console.error("GD solace Connection error: ", event);
    client.end();
    client = undefined;
    publishMessage(SOCKET_EVENT.SOLACE_ERROR, {
        method: SOLACE_CONNECTION_FAILED,
        reason: {
            reason: "SOLACE_CONNECTION_ERROR",
            error: event,
            options: options,
            isWindowFocused: isWindowFocused,
        },
    });
    if (connectionStatusInterval) {
        clearTimeout(connectionStatusInterval);
        solaceConnectDuration = 0;
    }
    // https://stackoverflow.com/questions/40084398/is-onclose-always-called-after-onerror-for-websocket
    // handleClose();
    // console.log("ONERROR SCOKET");
};
// const closeWebSocket = (): void => {
//   isWindowFocused = false;
//   if (isSocketConnected && socket) {
//     socket.close();
//   }
// };
export const reSubscribeSocket = (localClientCode) => {
    isWindowFocused = true;
    try {
        if (client) {
            if (isSocketConnected) {
                if (!dataUpdateInterval) {
                    //Commented to remove throttling
                    dataUpdateInterval = setInterval(() => {
                        checkSyncTimeAndDispatchData();
                    }, 500);
                }
                sendAllMessage(subscriberList);
                if (!dataCheckerInterval) {
                    publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                        resetLastSyncTime: "RESUBSCRIBED",
                    });
                    publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                        dataCheckForConnectedSocket: isSocketConnected,
                        isWindowFocused: isWindowFocused,
                    });
                }
            }
            // socket.close();
        }
        else {
            connectSolaceClient();
        }
    }
    catch (error) {
        console.error(error);
    }
};
const debugLogs = (solaceLogsArrayLocal, identifier) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (solaceLogsArrayLocal.length > 0) {
            let req = {
                eventType: "solaceDebugLogs",
                subEventType: identifier,
                message: {
                    logs: solaceLogsArrayLocal,
                    clientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
                },
            };
            let res = yield analyticsAPIClickhouse([req]);
            if (!res) {
                publishMessage(SOCKET_EVENT.ANALYTICS_API_FAILURE, {
                    method: ANALYTICS_API_FAILURE,
                    reason: {
                        reason: ANALYTICS_API_FAILURE,
                    },
                });
            }
        }
    }
    catch (error) {
        console.error(error);
        publishMessage(SOCKET_EVENT.ANALYTICS_API_FAILURE, {
            method: ANALYTICS_API_FAILURE,
            reason: {
                reason: ANALYTICS_API_FAILURE,
                //logs: solaceLogsArrayLocal,
            },
        });
    }
});
export const connectSolaceClient = () => {
    const tlsOptions = {
        rejectUnauthorized: false,
        secureProtocol: "TLSv1_2_method",
        checkServerIdentity: (servername, cert) => {
            return true;
        },
    };
    const options = {
        protocolVersion: SOLACE.PROTOCOLVERSION,
        clean: SOLACE.CLEAN,
        reconnectPeriod: SOLACE.RECONNECTPERIOD,
        connectTimeout: SOLACE.CONNECTTIMEOUT,
        username: "",
        password: "",
        LastWillQos: SOLACE.LASTWILQOS,
        LastWillRetain: SOLACE.LASTWILLRETAIN,
        keepAlive: SOLACE.KEEPALIVE,
        tlsOptions: tlsOptions,
        rejectUnauthorized: SOLACE.REJECTUNAUTHORIZED,
        checkServerIdentity: (servername, cert) => {
            return true;
        },
        clientId: "",
        // clientId: clientCode + "web" + moment().format(SOLACE_TIME_FORMAT),
        log: (...args) => {
            if (shouldLog) {
                solaceLogsArray.push(args);
            }
        },
    };
    try {
        if (client) {
            // Client is already connected or connecting
            return;
        }
        const solaceCred = getDataFromSession(SESSION_KEYS.SOLACE_CLIENT);
        solaceTimer = getDataFromSession(SESSION_KEYS.SOLACE_TIMER);
        if (solaceCred) {
            username = newDecrypt(solaceCred);
        }
        else {
            store.dispatch(setisSolaceEnabled(false));
            publishMessage(SOCKET_EVENT.SOLACE_ERROR, {
                method: SOLACE_CONNECTION_FAILED,
                reason: {
                    reason: "SOLACE_CRED_NOT_FOUND",
                    options: options,
                    solaceCred: solaceCred,
                    isWindowFocused: isWindowFocused,
                },
            });
            // console.log("GD Solace client not enabled because username not found");
            return;
        }
        const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
        options.username = username;
        options.password = username;
        options.clientId = clientCode + "web" + moment().format(SOLACE_TIME_FORMAT);
        solaceConnectDuration = new Date().getTime();
        shouldLog = true;
        client = MQTT.connect(SOLACE.BROKER_URL, options);
        setSocketInitLoading(true);
        setTimeout(() => {
            try {
                if (isSolaceConnect == false) {
                    //BREAK RETRY CONNECTION
                    setDataInSession(SESSION_KEYS.SOLACE_ERROR, true);
                    publishMessage(SOCKET_EVENT.SOLACE_ERROR, {
                        method: SOLACE_CONNECTION_FAILED,
                        reason: {
                            reason: SOLACE_CONNECTION_FAILED,
                            options: options,
                            timeoutValue: 5000,
                            isWindowFocused: isWindowFocused,
                        },
                    });
                }
            }
            catch (error) {
                console.error(error);
            }
        }, 5000);
        setTimeout(() => {
            try {
                if (isSolaceConnect == false) {
                    //BREAK RETRY CONNECTION
                    debugLogs(solaceLogsArray, "solaceConnectTimeout");
                    client.end();
                    client = undefined;
                    setDataInSession(SESSION_KEYS.SOLACE_ERROR, true);
                    publishMessage(SOCKET_EVENT.SOLACE_ERROR, {
                        method: SOLACE_CONNECTION_FAILED,
                        reason: {
                            reason: SOLACE_CONNECTION_FAILED,
                            options: options,
                            timeoutValue: solaceTimer * 1000,
                            isWindowFocused: isWindowFocused,
                        },
                    });
                    // solaceLogsArray = [];
                }
                else {
                    // let duration = new Date().getTime() - solaceConnectDuration;
                    setDataInSession(SESSION_KEYS.SOLACE_ERROR, false);
                    setDataInSession(SESSION_KEYS.SOLACE_ENABLED, true);
                    // debugLogs(solaceLogsArray, "solaceConnectTimeout");
                    // publishMessage(SOCKET_EVENT.SOLACE_CONNECTED, {
                    //   method: SOLACE_CONNECTION_SUCCESS,
                    //   reason: { reason: SOLACE_SOCKET_CONNECT, options: options, solace_cred: solaceCred , duration: duration,isWindowFocused: isWindowFocused},
                    // });
                    // solaceConnectDuration = 0
                }
                shouldLog = false;
                solaceLogsArray = [];
            }
            catch (error) {
                console.error(error);
            }
        }, solaceTimer * 1000);
        if (client) {
            client.on("connect", () => onSocketOpen(false));
            client.on("error", (e) => onSocketError(e, options));
            client.on("reconnect", () => onSocketOpen(true)); // new method and set duration
            client.on("message", (topicName, message) => {
                convertBinaryToJSONAndDispatch(topicName, message);
            });
        }
    }
    catch (error) {
        publishMessage(SOCKET_EVENT.SOLACE_ERROR, {
            method: SOLACE_CONNECTION_FAILED,
            reason: {
                reason: "SOLACE_CONNECTION_FAILURE_WORKER",
                error: error,
                options: options,
                isWindowFocused: isWindowFocused,
            },
        });
        console.error(error);
        setDataInSession(SESSION_KEYS.SOLACE_ERROR, true);
        shouldLog = false;
        debugLogs(solaceLogsArray, "solaceConnectError");
        solaceLogsArray = [];
    }
};
export const solace = (topicName, message) => {
    // connectClient();
    if (message === "Subscribe") {
        subscribeTopic(topicName);
    }
    else if (message.toLowerCase() === "unsubscribe") {
        unsubscribeFromTopic(topicName);
    }
};
export const subscribeTopic = (topic) => {
    client.subscribe(topic, (err) => {
        if (err) {
            // console.error(err, `GD Error subscribing to topic: ${err}`);
            publishMessage(SOCKET_EVENT.SOLACE_ERROR, {
                method: SOLACE_CONNECTION_FAILED,
                reason: {
                    reason: "SOLACE_SUBSCRIBE_ERROR",
                    error: err === null || err === void 0 ? void 0 : err.message,
                    client: JSON.stringify(client),
                    isWindowFocused: isWindowFocused,
                },
            });
        }
        else {
            // console.log(err, `GD Subscribed to topic: ${topic}`);
        }
    });
};
export const unsubscribeFromTopic = (topic) => {
    client.unsubscribe(topic, (err) => {
        if (err) {
            // console.error(err, `GD Error unsubscribing from topic: ${err}`);
            publishMessage(SOCKET_EVENT.SOLACE_ERROR, {
                method: SOLACE_CONNECTION_FAILED,
                reason: {
                    reason: "SOLACE_UNSUBSCRIBE_ERROR",
                    error: err === null || err === void 0 ? void 0 : err.message,
                    client: JSON.stringify(client),
                    isWindowFocused: isWindowFocused,
                },
            });
            // client.end();
        }
        else {
            // console.log(err, `GD Unsubscribed from topic: ${topic}`);
        }
    });
    //   Unsubscribe from the current topic
};
const randomMessageGenerator = (isEven) => {
    let seconds = new Date().getSeconds();
    //This is done so ticker size is 5 paisa only
    if (seconds > 5) {
        seconds = seconds - (seconds % 5);
    }
    else {
        seconds = 0;
    }
    Object.keys(scripMap).forEach((singleKey) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const scripObj = scripMap[singleKey];
        if (scripObj && scripObj.subscribers.length > 0) {
            if ((_b = (_a = scripObj.data) === null || _a === void 0 ? void 0 : _a.marketFeedData) === null || _b === void 0 ? void 0 : _b.response) {
                const dataToSend = Object.assign({}, (_c = scripObj.data) === null || _c === void 0 ? void 0 : _c.marketFeedData.response);
                // dataToSend.PClose = dataToSend.PClose;
                // dataToSend.LastRate = dataToSend.LastRate + seconds * 10;
                dataToSend.LastRate = dataToSend.LastRate + seconds / 100;
                // if (singleKey.includes("37834")) {
                //   console.log(scripObj, new Date());
                // }
                handleAndDispatchMessage(dataToSend, SOCKET_SUBSCRIPTION_METHODS.MARKET_FEED_V3);
            }
            if ((_e = (_d = scripObj.data) === null || _d === void 0 ? void 0 : _d.openInterest) === null || _e === void 0 ? void 0 : _e.response) {
                const dataToSend = Object.assign({}, (_f = scripObj.data) === null || _f === void 0 ? void 0 : _f.openInterest.response);
                dataToSend.OpenInterest = dataToSend.OpenInterest + seconds / 100;
                handleAndDispatchMessage(dataToSend, SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE);
            }
            if ((_h = (_g = scripObj.data) === null || _g === void 0 ? void 0 : _g.marketDepthData) === null || _h === void 0 ? void 0 : _h.response) {
                // const dataToSend = { ...scripObj.data?.marketDepthData.response };
                const dataToSend = JSON.parse(JSON.stringify((_j = scripObj.data) === null || _j === void 0 ? void 0 : _j.marketDepthData.response));
                if (dataToSend.Details.length == 0) {
                    dataToSend.Details.push({
                        Quantity: 999,
                        Price: 123,
                        NumberOfOrders: 100,
                        BbBuySellFlag: 66,
                    });
                }
                dataToSend.Details[0].Price =
                    dataToSend.Details[0].Price + seconds / 100;
                dataToSend.Details[0].Quantity =
                    dataToSend.Details[0].Quantity + seconds;
                dataToSend.Details[0].NumberOfOrders =
                    dataToSend.Details[0].NumberOfOrders + seconds;
                handleAndDispatchMessage(dataToSend, SOCKET_SUBSCRIPTION_METHODS.SCRIPT_INFO_FOR_FUTURE);
            }
            if (((_l = (_k = scripObj.data) === null || _k === void 0 ? void 0 : _k.greekFeedData) === null || _l === void 0 ? void 0 : _l.response) == undefined) {
                const dataToSend = {
                    PacketIdentifier: "G",
                    MessageLength: 200,
                    Token: Number(singleKey.replace("ND", "")),
                    IV: 0.01 + seconds / 10000,
                    DELTA: 0.02 + seconds / 10000,
                    THETA: 0.03 + seconds / 10000,
                    VEGA: 0.04 + seconds / 10000,
                    GAMMA: 0.05 + seconds / 10000,
                    IV_VWAP: 0.06 + seconds / 10000,
                    VANNA: 0.07 + seconds / 10000,
                    CHARM: 0.08 + seconds / 10000,
                    SPEED: 0.09 + seconds / 10000,
                    ZOMMA: 0.1 + seconds / 10000,
                    COLOR: 0.11 + seconds / 10000,
                    VOLGA: 0.12 + seconds / 10000,
                    VETA: 0.13 + seconds / 10000,
                    TGR: 0.14 + seconds / 10000,
                    TV: 0.15 + seconds / 10000,
                    DTR: 0.16 + seconds / 10000,
                };
                handleAndDispatchMessage(dataToSend, SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS);
            }
        }
    });
    setTimeout(() => {
        randomMessageGenerator(isEven);
    }, 1000);
};
if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "development") {
    // randomMessageGenerator(true);
}
if (REACT_APP_ENV == "development") {
    // randomMessageGenerator(true);
}
const publishMessage = (eventType, data) => {
    // if (eventType == SOCKET_EVENT.MARKETFEED_DATA && data.Token == "999920000") {
    //   console.log(Date.now(), "This is a tribute to Nifty", data);
    // }
    const output = { eventType: eventType, data: data };
    handleMessageFromSocket(output);
    // self.postMessage(jsonToUint(output));
};
self.onmessage = (e) => {
    const inputEvent = e.data;
    handleSocketEvent(inputEvent);
};
export const handleSocketEvent = (inputEvent) => {
    try {
        switch (inputEvent.eventType) {
            case SOCKET_EVENT.CONNECT_SOCKET: {
                // clientCode = inputEvent.data.clientCode;
                //These two lines commented for running in main thread
                // const sessionData = inputEvent.data.sessionData;
                // setSessionData(JSON.stringify(sessionData));
                connectSolaceClient();
                // subscribeToData(
                //   {
                //     Method: "MarketFeedV3",
                //     Operation: "subscribe",
                //     ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
                //     MarketFeedData: [
                //       {
                //         Exch: "N",
                //         ExchType: "C",
                //         ScripCode: 999920000,
                //       },
                //     ],
                //   },
                //   "SELF"
                // );
                break;
            }
            case SOCKET_EVENT.SUBSCRIBE:
                subscribeToData(inputEvent.data, inputEvent.data.subscriberName);
                break;
            case SOCKET_EVENT.UNSUBSCRIBE:
                unsubscribeDataByScrip(inputEvent.data.subscriberName, inputEvent.data.scripData, inputEvent.data.methodName);
                // sendMessage(inputEvent.data);
                break;
            case SOCKET_EVENT.UNSUBSCRIBE_BY_SUBSCRIBER:
                unsubscribeDataBySubscriber(inputEvent.data.subscriberName, inputEvent.data.methodName);
                // sendMessage(inputEvent.data);
                break;
            case SOCKET_EVENT.IS_WINDOW_FOCUSED: {
                isWindowFocused = inputEvent.data;
                if (isWindowFocused) {
                    reSubscribeSocket(getDataFromSession(SESSION_KEYS.CLIENT_CODE));
                }
                else {
                    publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                        resetLastSyncTime: "WINDOW_NOT_FOCUSED",
                    });
                    unSubscribeAllData();
                    publishMessage(SOCKET_EVENT.LOGGLY_DATA, {
                        method: "SOCKET_DATA_STREAM_STOPPED",
                        reason: { reason: "WINDOW_NOT_FOCUSED" },
                    });
                }
                break;
            }
            default:
                break;
        }
        // self.postMessage({ simpleKey: "Yo yo" });
    }
    catch (error) {
        console.error(error);
    }
};
//For testing only
// self.onmessage = (e: MessageEvent<any>) => {
//   try {
//     console.log("This is a tribute from serivce worker", e, e.data);
//     clientCode = e.data.clientCode;
//     socketUrl = e.data.wsUrl;
//     const sessionData = {};
//     sessionData[SESSION_KEYS.CLIENT_CODE] = clientCode;
//     try {
//       const sessionClientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
//       console.log(sessionClientCode);
//     } catch (error) {
//       console.error(error);
//     }
//     setSessionData(JSON.stringify(sessionData));
//     initWebSocket(socketUrl, true);
//     subscribeToData(
//       {
//         Method: "MarketFeedV3",
//         Operation: "subscribe",
//         ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
//         MarketFeedData: [
//           {
//             Exch: "N",
//             ExchType: "C",
//             ScripCode: 999920000,
//           },
//         ],
//       },
//       "SELF",
//       () => {}
//     );
//     // reSubscribeDepthSocket(clientCode);
//     self.postMessage({ simpleKey: "Yo yo" });
//   } catch (error) {
//     console.error(error);
//   }
// };
const convertBinaryToJSONAndDispatch = (topicName, message) => {
    const dataType = getMethodTypeFromTopic(topicName);
    if (dataType == SOCKET_SUBSCRIPTION_METHODS.DEPTH_20_SERVICE) {
        const resultObject = convertDepthBinaryToJSON(topicName, message);
        handleAndDispatchMessage(resultObject, SOCKET_SUBSCRIPTION_METHODS.DEPTH_20_SERVICE);
    }
    else if (dataType == SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS) {
        const resultObject = convertGreeksBinaryToJSON(topicName, message);
        handleAndDispatchMessage(resultObject, SOCKET_SUBSCRIPTION_METHODS.BASE_GREEKS);
    }
};
const convertDepthBinaryToJSON = (topicName, message) => {
    var _a, _b;
    const parsedData = parseTopic(topicName);
    const binaryArray = message;
    const arrayConfig = [
        { SN: "Quantity", type: "Int32", length: 4 },
        { SN: "Price", type: "Int32", length: 4 },
        { SN: "NumberOfOrders", type: "Int32", length: 4 },
        { SN: "BbBuySellFlag", type: "Byte", length: 0 },
    ];
    let count = 0;
    const resultObject = {};
    let result;
    resultObject["Details"] = [];
    for (let i = 0; i < 40; i++) {
        const singleDepthItem = {};
        for (const field of arrayConfig) {
            if (field.type === "Int32") {
                result = intFromBytes(binaryArray.slice(count, count + field.length));
                if (field.SN === "Price") {
                    result = result / 100;
                }
                singleDepthItem[field.SN] = result;
                count += field.length;
            }
            else if (field.type === "Byte") {
                let tempVariable;
                if (i < 20) {
                    tempVariable = 66;
                }
                else {
                    tempVariable = 83;
                }
                singleDepthItem[field.SN] = tempVariable;
            }
        }
        resultObject["Details"].push(singleDepthItem);
    }
    resultObject["Exch"] = (_a = parsedData.exchange) === null || _a === void 0 ? void 0 : _a.toUpperCase();
    resultObject["ExchType"] = (_b = parsedData.exchangeType) === null || _b === void 0 ? void 0 : _b.toUpperCase();
    resultObject["Token"] = parseInt(parsedData.scripcode);
    resultObject["TBidQ"] = "0000";
    resultObject["TOffQ"] = "0000";
    // console.log(
    //   "GD message received from solace for topic : " + topicName,
    //   resultObject
    // );
    return resultObject;
};
const convertGreeksBinaryToJSON = (topicName, message) => {
    const binaryArray = message;
    const scripCode = Number(topicName.replace(SOLACE_GREEKS_TOPIC_PREFIX, ""));
    const arrayConfig = [
        { SN: "PacketIdentifier", type: "Char", length: 4 },
        { SN: "MessageLength", type: "Short", length: 4 },
        { SN: "Token", type: "Int", length: 2 },
        { SN: "TWAPIV", type: "Float", length: 2 },
    ];
    const config = [
        { SN: "PacketIdentifier", type: "Char", length: 1 },
        { SN: "MessageLength", type: "Short", length: 2 },
        { SN: "Token", type: "Int", length: 4 },
        { SN: "IV", type: "Float", length: 4 },
        { SN: "DELTA", type: "Float", length: 4 },
        { SN: "THETA", type: "Float", length: 4 },
        { SN: "VEGA", type: "Float", length: 4 },
        { SN: "GAMMA", type: "Float", length: 4 },
        { SN: "IV_VWAP", type: "Float", length: 4 },
        { SN: "VANNA", type: "Float", length: 4 },
        { SN: "CHARM", type: "Float", length: 4 },
        { SN: "SPEED", type: "Float", length: 4 },
        { SN: "ZOMMA", type: "Float", length: 4 },
        { SN: "COLOR", type: "Float", length: 4 },
        { SN: "VOLGA", type: "Float", length: 4 },
        { SN: "VETA", type: "Float", length: 4 },
        { SN: "TGR", type: "Float", length: 4 },
        { SN: "TV", type: "Float", length: 4 },
        { SN: "DTR", type: "Float", length: 4 },
        // { SN: "PacketIdentifier", type: "Char", length: 1 },
        // { SN: "MessageLength", type: "Short", length: 2 },
        // { SN: "Token", type: "Int", length: 4 },
        // { SN: "TWAPIV", type: "Float", length: 4 },
        // { SN: "PacketIdentifier", type: "Char", length: 1 },
        // { SN: "MessageLength", type: "Short", length: 2 },
        // { SN: "Token", type: "Int", length: 4 },
        // { SN: "TWAPIV", type: "Float", length: 4 },
        // { SN: "PacketIdentifier", type: "Char", length: 1 },
        // { SN: "MessageLength", type: "Short", length: 2 },
        // { SN: "Token", type: "Int", length: 4 },
        // { SN: "TWAPIV", type: "Float", length: 4 },
    ];
    let count = 0;
    const resultObject = { Token: scripCode, Exch: "N", ExchType: "D" };
    for (const field of config) {
        // const parser = parsers[field.type];
        const length = field.length;
        if (field.type === "Int") {
            const result = intFromBytes(binaryArray.slice(count, count + length));
            resultObject[field.SN] = result;
            // count += 1;
        }
        if (field.type === "Char") {
            const result = charFromBytes(binaryArray.slice(count, count + length));
            resultObject[field.SN] = result;
            // count += 1;
        }
        if (field.type === "Short") {
            const result = shortFromBytes(binaryArray.slice(count, count + length));
            resultObject[field.SN] = result;
            // count += 1;
        }
        if (field.type === "Float") {
            const result = floatFromBytes(binaryArray.slice(count, count + length));
            resultObject[field.SN] = result;
            // count += 1;
        }
        count += length;
    }
    // if (scripCode == 58684) {
    //   console.log(
    //     "GD message received from solace for topic : " + topicName,
    //     resultObject
    //   );
    // }
    return resultObject;
};
//For testing only
// self.onmessage = (e: MessageEvent<any>) => {
//   try {
//     console.log("This is a tribute from serivce worker", e, e.data);
//     clientCode = e.data.clientCode;
//     socketUrl = e.data.wsUrl;
//     const sessionData = {};
//     sessionData[SESSION_KEYS.CLIENT_CODE] = clientCode;
//     try {
//       const sessionClientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
//       console.log(sessionClientCode);
//     } catch (error) {
//       console.error(error);
//     }
//     setSessionData(JSON.stringify(sessionData));
//     initWebSocket(socketUrl, true);
//     subscribeToData(
//       {
//         Method: "MarketFeedV3",
//         Operation: "subscribe",
//         ClientCode: getDataFromSession(SESSION_KEYS.CLIENT_CODE),
//         MarketFeedData: [
//           {
//             Exch: "N",
//             ExchType: "C",
//             ScripCode: 999920000,
//           },
//         ],
//       },
//       "SELF",
//       () => {}
//     );
//     // reSubscribeDepthSocket(clientCode);
//     self.postMessage({ simpleKey: "Yo yo" });
//   } catch (error) {
//     console.error(error);
//   }
// };
// export const solaceGreeks = (topicName, Message): any => {
//   if (!client) {
//     connectClient();
//     console.log(client, "Connect the client if it's not already connected"); // Connect the client if it's not already connected
//   }
//   // client.on("connect", (err) => {
//   //   if (err) {
//   //     console.log("client not able to connect");
//   //     // store.dispatch(setSolaceConnected(false));
//   //   } else {
//   //     // connectClient();
//   //     store.dispatch(setSolaceSocket(client));
//   //     store.dispatch(setSolaceConnected(true));
//   //     console.log("client connected succesful ");
//   //   }
//   //this code is for only UAT
//   client.subscribe(topicName, (err) => {
//     if (!err) {
//       console.log(`Subscribed to topic: ${topicName}`);
//     } else {
//       console.error(`Error subscribing to topic: ${err}`);
//     }
//   });
//   // });
//   client.on("message", function (topic, message) {
//     console.log(topic, message, "----------===");
//     const binaryArray = message;
//     console.log(message.length, "length");
//     const arrayConfig: ConfigField1[] = [
//       { SN: "PacketIdentifier", type: "Char", length: 4 },
//       { SN: "MessageLength", type: "Short", length: 4 },
//       { SN: "Token", type: "Int", length: 2 },
//       { SN: "TWAPIV", type: "Float", length: 2 },
//     ];
//     const config: ConfigField1[] = [
//       { SN: "PacketIdentifier", type: "Char", length: 1 },
//       { SN: "MessageLength", type: "Short", length: 2 },
//       { SN: "Token", type: "Int", length: 4 },
//       { SN: "IV", type: "Float", length: 4 },
//       { SN: "DELTA", type: "Float", length: 4 },
//       { SN: "THETA", type: "Float", length: 4 },
//       { SN: "VEGA", type: "Float", length: 4 },
//       { SN: "GAMMA", type: "Float", length: 4 },
//       { SN: "IV_VWAP", type: "Float", length: 4 },
//       { SN: "VANNA", type: "Float", length: 4 },
//       { SN: "CHARM", type: "Float", length: 4 },
//       { SN: "SPEED", type: "Float", length: 4 },
//       { SN: "ZOMMA", type: "Float", length: 4 },
//       { SN: "COLOR", type: "Float", length: 4 },
//       { SN: "VOLGA", type: "Float", length: 4 },
//       { SN: "VETA", type: "Float", length: 4 },
//       { SN: "TGR", type: "Float", length: 4 },
//       { SN: "TV", type: "Float", length: 4 },
//       { SN: "DTR", type: "Float", length: 4 },
//       // { SN: "PacketIdentifier", type: "Char", length: 1 },
//       // { SN: "MessageLength", type: "Short", length: 2 },
//       // { SN: "Token", type: "Int", length: 4 },
//       // { SN: "TWAPIV", type: "Float", length: 4 },
//       // { SN: "PacketIdentifier", type: "Char", length: 1 },
//       // { SN: "MessageLength", type: "Short", length: 2 },
//       // { SN: "Token", type: "Int", length: 4 },
//       // { SN: "TWAPIV", type: "Float", length: 4 },
//       // { SN: "PacketIdentifier", type: "Char", length: 1 },
//       // { SN: "MessageLength", type: "Short", length: 2 },
//       // { SN: "Token", type: "Int", length: 4 },
//       // { SN: "TWAPIV", type: "Float", length: 4 },
//     ];
//     let count = 0;
//     const resultObject = {};
//     for (const field of config) {
//       // const parser = parsers[field.type];
//       const length = field.length;
//       if (field.type === "Int") {
//         const result = intFromBytes(binaryArray.slice(count, count + length));
//         resultObject[field.SN] = result;
//         // count += 1;
//       }
//       if (field.type === "Char") {
//         const result = charFromBytes(binaryArray.slice(count, count + length));
//         resultObject[field.SN] = result;
//         // count += 1;
//         console.log(result, "char result");
//       }
//       if (field.type === "Short") {
//         const result = shortFromBytes(binaryArray.slice(count, count + length));
//         console.log("short result", result);
//         resultObject[field.SN] = result;
//         // count += 1;
//       }
//       if (field.type === "Float") {
//         const result = floatFromBytes(binaryArray.slice(count, count + length));
//         console.log("result float", result);
//         resultObject[field.SN] = result;
//         // count += 1;
//       }
//       count += length;
//     }
//     const resultJSON: any = resultObject;
//     console.log("topicNAme:", resultJSON, "data");
//     store.dispatch(setGreeksMsg(resultJSON));
//   });
// };
